export const PAGE_TOP_BAR_TEST_ID = 'horizontal-nav-page-topbar.ui.horizontal-nav-page-topbar';
export const PAGE_TOP_BAR_ACTIONS_TEST_ID =
	'horizontal-nav-page-topbar.ui.horizontal-nav-page-topbar.actions';
